export const setUploadRedirectURL = (redirectURL, documentType, sessionHash, sessionKey) => (
  (dispatch) => {
    dispatch({ type: 'SET_MODAL_UPLOAD_ONCLICK', redirectURL, documentType, sessionHash, sessionKey });
  }
);

export const disableDefaultDragAndDropTracking = () => (
  (dispatch) => {
    dispatch({ type: 'DISABLE_DEFAULT_DROP_UPLOAD_TRACKING' });
  }
);

export const enableDefaultDragAndDropTracking = () => (
  (dispatch) => {
    dispatch({ type: 'ENABLE_DEFAULT_DROP_UPLOAD_TRACKING' });
  }
);



// WEBPACK FOOTER //
// ./src-react/Upload/UploadActions.jsx